var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-location"},[_c('gmap-autocomplete',{staticClass:"a-input autocomplete",attrs:{"value":_vm.query,"placeholder":_vm.$ml.get("Enter location"),"select-first-on-enter":true},on:{"place_changed":_vm.setPlace}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }